import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { jwtDecode, JwtPayload } from 'jwt-decode'
import { Text, Image, Box } from '@chakra-ui/react'

import Tick from 'assets/images/tick.svg'
import { InformativeLayer } from 'components/informativeLayer'
import { validateToken } from 'services/api'
import { IReturnValidateToken, IValidateToken } from 'services/IApi.d'
import { useAuthContext } from 'providers/AuthProvider'
// import { useSubscriberContext } from 'providers/SubscriberProvider'

const EmailValidationSuccessPage = () => {
  const navigate = useNavigate()
  const { signinRedirect } = useAuthContext()
  // const { setSubscriberData } = useSubscriberContext()
  const [searchParams] = useSearchParams()
  const [loading, setLoading] = React.useState<boolean>(true)
  const code: string = searchParams.get('code')
  const title: string = '¡Verificaste tu email, tu cuenta está lista!'
  const subtitle: string = 'Ahora solo debes iniciar sesión en la web de interbanking, puedes hacerlo clickeando en el botón de abajo'

  const loadValidateToken = async (validateTokenData: IValidateToken) => {
    const response: IReturnValidateToken = await validateToken(validateTokenData)
    if (!response?.data?.esTokenValido) {
      navigate('/suscripcion/error-correo', { state: { pageBefore: 'subscriptorFlow' } })
    }
    return response
  }

  useEffect(() => {
    const decoded: any = jwtDecode<JwtPayload>(code)
    const { canal, fechaHoraSolicitud, requestId } = decoded
    // TODO: Uncomment after know if use same page error in both flows (recovery and subscriber)
    // setSubscriberData((old) => ({ ...old, email: destinoNotificacion }))
    loadValidateToken({
      canal,
      fechaHoraToken: fechaHoraSolicitud,
      requestId,
      token: code,
    }).then(() => {
      setLoading(false)
    })
  }, [])

  return (
    <Box>
      <InformativeLayer
        title={<Text>{title}</Text>}
        subtitle={<Text>{subtitle}</Text>}
        Image={<Image src={Tick} alt='Lateral image' />}
        action={signinRedirect}
        isLoading={loading}
      />
    </Box>
  )
}

export default EmailValidationSuccessPage
